import {
  createEffect,
  ofType,
  registerEffects,
  removeEffects,
  tapResult,
} from '@ngneat/effects';

import { setCurrentHelpVideo } from './vidyard.actions';
import { updateCurrentVideo } from './vidyard.repository';

const setCurrentHelpVideo$ = createEffect((actions) =>
  actions.pipe(
    ofType(setCurrentHelpVideo),
    tapResult(({ video }) => {
      updateCurrentVideo(video);
    })
  )
);

const effects = [setCurrentHelpVideo$];

export function registerVidyardEffects() {
  registerEffects(effects);
}

export function deregisterVidyardEffects() {
  removeEffects(effects);
}
